/**
 * NotFound — the catch-all route.
 *
 * QG-CLI-PAGES-002: no route table in the app declared `path: '*'`, so an unmatched URL
 * rendered the Layout chrome with an empty content area and no explanation. That is worse
 * than a 404: a user (or an agent following a stale link) cannot tell "this page does not
 * exist" from "this page failed to load". QG-CLI-PAGES-004 found two such links shipped in
 * the nav, which is exactly how someone lands here.
 *
 * Template example: NextAdmin `(pages)/error-page/page.tsx` (demo `/error-page`).
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { StatusPage } from '../components/page/StatusPage.js';
import { PageHeader } from '../components/ui/PageHeader.js';

export const NotFound: React.FC = () => {
  const location = useLocation();

  return (
    <div className="space-y-5">
      <PageHeader title="Page not found" />
      <StatusPage
        title="Page not found!"
        description={
          <>
            <p>Nothing is routed at {location.pathname}.</p>
            <p>The link may be out of date, or the feature may belong to a module that is not enabled for you.</p>
          </>
        }
        action={{ label: 'Back to home', to: '/' }}
      />
    </div>
  );
};

export default NotFound;
